module.exports = __webpack_public_path__ + "static/feedback-form-08e4f26b4503b35f8199cf0f07edc49c.png";